import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard'
import { alterSnackbar } from '~/data/actions/siteActions'
import codesExamples from './codeExamples'
import params from './codeParameters'
import AceEditor from 'react-ace'

export default function SmsTransactionSettings() {
    const dispatch = useDispatch()
    const site = useSelector((state) => state.siteMaster)
    const parameters = useRef(null)

    const [token, setToken] = useState(null)
    const [code, setCode] = useState('javascript')
    const options = Object.keys(codesExamples)
    const codes = useCodes(token)

    const copyToClipboard = (value) => {
        copy(value)
        dispatch(alterSnackbar(true, i18n.t('campaigns:transactions.copiedToClipBoard')))
    }

    useEffect(() => {
        axios.get('/accountMaster/apikey?transaction=true').then((response) => {
            var keys = response.data.ApiKeys
            if (keys && keys.length) {
                setToken(keys[0].apiKey)
            }
        })
    }, [])

    return (
        <div>
            <div className='page-header mar-b25'>SMS Settings</div>

            <Row>
                <Column xs={12} sm={12} md={12} lg={6}>
                    <Paper>
                        <h4 className='mar-b25'>Send Via the Api</h4>
                        <TextInput
                            type='text'
                            value={'https://' + site.trackingDomain + '/transaction/sms'}
                            outerClassName='mar-b25'
                            label={i18n.t('campaigns:transactions.apiEndPoint')}
                        />

                        <TextArea
                            value={token}
                            outerClassName='mar-b25'
                            style={{ height: '100px' }}
                            label={i18n.t('campaigns:transactions.yourAccessToken')}
                            iconRight={
                                <Icons
                                    icon='copyClipboard'
                                    onClick={() => copyToClipboard(token)}
                                    alt={i18n.t('campaigns:transactions.copyToClipBoard')}
                                    title={i18n.t('campaigns:transactions.copyToClipBoard')}
                                />
                            }
                        />
                    </Paper>

                    <Paper>
                        <Row>
                            <Column xs={12} margin={0} ref={parameters}>
                                <h4 className='mar-b25'>{i18n.t('campaigns:transactions.authentication')}</h4>
                                <div className='mar-b25'>
                                    You must add <strong>x-access-token</strong> to the header of the request and your{' '}
                                    <strong>token</strong> (above) as the value
                                </div>

                                <h4 className='mar-b25'>{i18n.t('campaigns:transactions.parameters')}</h4>
                                {params.request.map((row, index) => {
                                    return (
                                        <TextInput
                                            key={'auth_' + index}
                                            type='text'
                                            explainer={row.description}
                                            value={row.field}
                                            outerClassName='mar-b25'
                                            iconRight={
                                                row.required && (
                                                    <SquareChip
                                                        className='square-chip-orange'
                                                        value={i18n.t('campaigns:transactions.required')}
                                                    />
                                                )
                                            }
                                        />
                                    )
                                })}
                                <h4 className='mar-b25'>{i18n.t('campaigns:transactions.response')}</h4>
                                {params.response.map((row, index) => {
                                    return (
                                        <TextInput
                                            key={'authR_' + index}
                                            type='text'
                                            explainer={row.description}
                                            value={row.field}
                                            outerClassName='mar-b25'
                                            iconRight={
                                                row.required && (
                                                    <SquareChip
                                                        className='square-chip-orange'
                                                        value={i18n.t('campaigns:transactions.required')}
                                                    />
                                                )
                                            }
                                        />
                                    )
                                })}
                            </Column>
                        </Row>
                    </Paper>
                </Column>
                <Column xs={12} sm={12} md={12} lg={6}>
                    <Paper>
                        <div
                            className='quickFlex mar-b25'
                            style={{ justifyContent: 'space-between', alignContent: 'center' }}
                        >
                            <h4 className='no-marg'>{i18n.t('campaigns:transactions.sampleCode')}</h4>
                            <Select
                                align='right'
                                data={options}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                            />
                        </div>

                        <Paper style={{ padding: '0px', position: 'relative' }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '15px',
                                    right: '15px',
                                    zIndex: '1'
                                }}
                            >
                                <Icons
                                    icon='copyClipboard'
                                    style={{ width: '20px', height: '20px' }}
                                    alt={i18n.t('campaigns:transactions.copyToClipBoard')}
                                    title={i18n.t('campaigns:transactions.copyToClipBoard')}
                                    onClick={() => copyToClipboard(codes[code])}
                                />
                            </div>
                            <AceEditor
                                mode={code === 'curl' ? 'powershell' : code}
                                theme='xcode'
                                name='code'
                                width='100%'
                                readOnly={true}
                                wrapEnabled={true}
                                showPrintMargin={false}
                                editorProps={{ $blockScrolling: true }}
                                value={codes[code]}
                            />
                        </Paper>
                    </Paper>
                </Column>
            </Row>
        </div>
    )
}

function useCodes(token) {
    const site = useSelector((state) => state.siteMaster)
    const account = useSelector((state) => state.accountMaster)
    const user = useSelector((state) => state.user)

    var obj = {}
    Object.keys(codesExamples).forEach((prop) => {
        var code = codesExamples[prop]
        code = code.replace('{{url}}', site.trackingDomain)
        // companyName is account.accountmaster.accountName but only A-Z no spaces and up to 11 chars
        var companyName = account.accountMaster.accountName.replace(/[^a-zA-Z]/g, '')
        if (companyName.length > 11) {
            companyName = companyName.substring(0, 11)
        }
        code = code.replace('{{companyName}}', companyName)
        code = code.replace('{{emailAddress}}', user.userData.emailAddress)
        code = code.replace('{{toAddress}}', '+447711123456')
        code = code.replace('{{token}}', token)
        obj[prop] = code
    })
    return obj
}
